<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="submissions-page">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">IAR Submissions</h1>
        </header>
        <SubmissionsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import SubmissionsView from "./SubmissionsView.vue";
import {
  IngredientsAppGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import AccessHandler from "@/shared/access/AccessHandler.vue";

const roleGroups = [IngredientsAppGroup] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page {
  &__header--container {
    display: flex;
    align-items: center;
    margin-top: 30px;
    gap: 12px;
  }

  &__title--text {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-transform: uppercase;
  }
}
</style>
